import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

import Icon from 'dpl/common/components/Icon';
import useStoriesLabel from 'dpl/common/hooks/useStoriesLabel';

import ReviewsPhotos from './ReviewsPhotos';

const MIN_PHOTOS_TO_SHOW = 3;

/** @param {any} props */
export default function ReviewsCard({
  className = null,
  reviewCount,
  photographs,
  percentRecommend = null
}) {
  const { shortNoun } = useStoriesLabel(reviewCount);

  return (
    <div
      className={classnames(
        'ReviewsCard flex flex-column items-center gap-12 lh-title br3 bg-gray-100 ba b--gray-200 pt3 pb2 ph3',
        className
      )}
    >
      {photographs.length >= MIN_PHOTOS_TO_SHOW && (
        <ReviewsPhotos photographs={photographs} />
      )}
      <div className="flex flex-column items-center gap-8">
        {percentRecommend != null && (
          <p className="font-14 nowrap">{percentRecommend}% recommend</p>
        )}
        <p className="flex items-center gap-4 font-14 secondary">
          <Icon name="fetch-review" height="20px" width="20px" />
          <span className="nowrap">
            {reviewCount} owner {shortNoun}
          </span>
        </p>
      </div>
    </div>
  );
}

ReviewsCard.propTypes = {
  className: PropTypes.string,
  percentRecommend: PropTypes.number,
  reviewCount: PropTypes.number.isRequired,
  photographs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      url: PropTypes.string.isRequired
    })
  ).isRequired
};
